const NO_REFERRAL_CODE = 'no_referral_code';

export function getReferralCode(search: string) {
  const searchParams = new URLSearchParams(search);
  return searchParams.get('ref') ?? NO_REFERRAL_CODE;
}
